import { Injectable, signal } from '@angular/core';

/**
 * Temporarily silences the success toasts the MetaInterceptor shows for API
 * meta messages — e.g. while the dev tools fire hundreds of requests. Error
 * handling is unaffected. Re-entrant: nested runs keep the silence up until
 * the outermost one finishes.
 */
@Injectable({ providedIn: 'root' })
export class MetaMessageSilencerService {
  #silencedCount = signal(0);

  isSilenced(): boolean {
    return this.#silencedCount() > 0;
  }

  async runSilenced<T>(work: () => Promise<T>): Promise<T> {
    this.#silencedCount.update((silencedCount) => silencedCount + 1);

    try {
      return await work();
    } finally {
      this.#silencedCount.update((silencedCount) => silencedCount - 1);
    }
  }
}
